import type { QrCode } from "../../domain/entities/QrCode";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  if (!data) {
    return error instanceof Error ? error.message : fallback;
  }

  if (typeof data?.error?.message === "string") {
    return data.error.message;
  }

  if (typeof data?.message === "string") {
    return data.message;
  }

  if (typeof data?.detail === "string") {
    return data.detail;
  }

  // FastAPI validation errors: detail[0].msg reads "Value error, <reason>".
  if (Array.isArray(data?.detail) && typeof data.detail[0]?.msg === "string") {
    return data.detail[0].msg.replace(/^Value error,\s*/, "");
  }

  return fallback;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapQrCodeResponse = (payload: any): QrCode => {
  const result = payload?.data ?? payload ?? {};

  const qr_code_uri =
    result.qr_code_uri ??
    result.qrCodeUri ??
    result.otpauth_url ??
    result.otpauth_uri ??
    result.provisioning_uri ??
    "";

  const secret =
    result.secret ??
    result.totp_secret ??
    result.manual_entry_key ??
    result.key ??
    "";

  if (!qr_code_uri) {
    throw new Error("QR setup response is missing qr_code_uri");
  }

  if (!secret) {
    throw new Error("QR setup response is missing secret");
  }

  return { qr_code_uri, secret };
};
